<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="" v-if="user_addressLoaded">
        <form class="mc-form" id="deliveryAddress"  @submit.prevent="submitForm" method="post" autocomplete="off">
          <div class="mc-form__body">
            <div v-if="formSubmitted && !hasErrors" class="mc-form__message mc-form__message--success"> Данные сохранены. </div>
            <div v-if="serverError" class="mc-form__message mc-form__message--alert">
              {{ serverError }}
            </div>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field" :class="{ isError: errors.city }">
                <label class="mc-form__label" for="deliveryAddressCity">
                  Населенный пункт
                </label>
                <span v-if="errors.city" class="mc-form__error-text">
                  {{ errors.city }}
                </span>
                <div class="mc-form__search-wrapper" :class="{isFilled:cities.length > 0, isResultShown:cities.length > 0}">
                  <div class="mc-form__search">
                    <input type="hidden" v-model="formData.city_id">
                    <input @input="searchCity" class="mc-form__search-input js-input-search" id="deliveryAddressCity" type="text" :value="formData.city">
                    <button class="mc-form__search-button-delete js-button-delete" type="button">
                      <svg class="mc-form__search-icon-delete" width="20" height="20" viewBox="0 0 20 20">
                        <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="mc-form__search-result mc-search-result">
                    <div class="mc-search-result__inner">
                      <ul class="mc-search-result__list">
                        <li v-for="city in cities" class="mc-search-result__item">
                          <a @click="selectCity(city)" class="mc-search-result__link">
                            {{ city.DISPLAY }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mc-form__field"  :class="{ isError: errors.street }">
                <label class="mc-form__label" for="deliveryAddressStreet">
                  Улица
                </label>
                <span v-if="errors.street" class="mc-form__error-text">
                  {{ errors.street }}
                </span>
                <input class="mc-form__input" id="deliveryAddressStreet" type="text" v-model="formData.street">
              </div>
              <div class="mc-form__field" :class="{ isError: errors.house }">
                <label class="mc-form__label" for="deliveryAddressHouse">
                  Дом/корпус
                </label>
                <span v-if="errors.house" class="mc-form__error-text">
                  {{ errors.house }}
                </span>
                <input class="mc-form__input" id="deliveryAddressHouse" type="text" v-model="formData.house">
              </div>
              <div class="mc-form__field" :class="{ isError: errors.flat }">
                <label class="mc-form__label" for="deliveryAddressApartment">
                  Квартира
                </label>
                <span v-if="errors.flat" class="mc-form__error-text">
                  {{ errors.flat }}
                </span>
                <input class="mc-form__input" id="deliveryAddressApartment" type="text" v-model="formData.flat">
              </div>
            </fieldset>
            <button class="mc-button mc-button--color" type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? 'Сохранение...' : 'Сохранить' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {debounce} from "lodash";
import axios from "axios";
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      formData: {
        city: '',
        city_id: '',
        street: '',
        house: '',
        flat: ''
      },
      cities: [],
      isSubmitting: false,
      errors: {},
      serverError: ''
    }
  },
  mounted() {

  },
  async created() {
    await this.fetchUserAddress();
    this.formData.city_id = this.user_address.LOCATION;
    this.formData.city = this.user_address.LOCATION_NAME;
    this.formData.street = this.user_address.STREET;
    this.formData.house = this.user_address.HOUSE;
    this.formData.flat = this.user_address.FLAT;

  },
  computed: {
    ...mapGetters([
      'user_address',
      'user_addressLoading',
      'user_addressError',
      'user_addressLoaded',
    ]),
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchUserAddress'
    ]),
    searchCity(evt)  {
      this.formData.city = evt.target.value;
      this.actionSearchCity();
    },
    actionSearchCity: debounce(async function()  {
      const response = await axios.post('api/order/location/', {
        'select[1]': 'CODE',
        'select[2]': 'TYPE_ID',
        'select[VALUE]': 'ID',
        'select[DISPLAY]': 'NAME.NAME',
        'additionals[1]': 'PATH',
        'filter[=PHRASE]': this.formData.city,
        'filter[=NAME.LANGUAGE_ID]': 'ru',
        'filter[=SITE_ID]': 's1',
        version: 2,
        PAGE_SIZE: 10,
        PAGE: 0,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this.cities = response.data.data
      /* else
         this.cities = [];*/
    }, 300),
    selectCity(city) {
      this.cities = [];
      this.formData.city_id = city['VALUE'];
      this.formData.city = city['DISPLAY'];
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        // Find first error element or server error message
        const firstErrorElement = this.serverError
            ? document.querySelector('.mc-form__message--alert')
            : document.querySelector('.isError');

        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },

    validateForm() {
      this.errors = {};

      // Validate surname
      if (!this.formData.city || !this.formData.city.trim()) {
        this.errors.city = 'Населенный пункт обязателен';
      } else if (this.formData.city.length < 2) {
        this.errors.city = 'Населенный пункт должен содержать минимум 2 символа';
      }

      // Validate name
      if (!this.formData.street || !this.formData.street.trim()) {
        this.errors.street = 'Улица обязательна';
      } else if (this.formData.street.length < 2) {
        this.errors.street = 'Улица должно содержать минимум 2 символа';
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },

    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.serverError = null;

      try {
        // Prepare data for submission
        const formDataToSubmit = {
          ...this.formData
        };




        const response = await axios.post('api/user/address/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'cert')
              this.errors[response.data.errors[i].code] = response.data.errors[i].message;
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }

        this.formSubmitted = true;
        this.$store.dispatch('Auth', response.data.data)
        // Scroll to the success message
        this.$nextTick(() => {
          const successMessage = document.querySelector('.mc-form__message--success');
          if (successMessage) {
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

      } catch (error) {
        let errorMessage = 'Произошла техническая ошибка. Попробуйте еще раз.';

        /* if (error.response && error.response.data) {
           // Handle axios error responses
           errorMessage = error.response.data.message || errorMessage;
         } else if (error.message) {
           // Use the thrown error message
           errorMessage = error.message;
       }*/
        if (!this.serverError)
          this.serverError = errorMessage;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    }
  },
}
</script>

